import React from "react";

const SchemaContact = () => {
  const schema = {
  "@context": "https://schema.org",
  "@type": "Hospital",
  "@id": "https://aarogyamhdna.com/#hospital",
  "name": "HDNA Aarogyam Hospital",
  "url": "https://aarogyamhdna.com/",
  "logo": "https://aarogyamhdna.com/logo.png",
  "image": [
    "https://aarogyamhdna.com/assets/images/hospital-banner.jpg",
    "https://aarogyamhdna.com/assets/images/icu-facilities.jpg"
  ],
  "description": "HDNA Aarogyam Hospital is a multispecialty hospital in Patna delivering compassionate, advanced healthcare in cardiac, renal, neuro, orthopedic and critical care services.",
  "telephone": "+91-8544015151",
  "email": "info@aarogyamhdna.com",
  "openingHours": "Mo-Su 00:00-23:59",
  "priceRange": "₹₹₹",

  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Off Bailey Road, Behind Damro Showroom & Maruti Alankar Showrooms, Rupaspur, IAS Colony",
    "addressLocality": "Patna",
    "addressRegion": "Bihar",
    "postalCode": "801503",
    "addressCountry": "IN"
  },

  "geo": {
    "@type": "GeoCoordinates",
    "latitude": 25.608138,
    "longitude": 85.060223
  },

  "medicalSpecialty": [
    "https://schema.org/Cardiovascular",
    "https://schema.org/Anesthesia",
    "https://schema.org/Emergency",
    "https://schema.org/PrimaryCare",
    "https://schema.org/Endocrine",
    "https://schema.org/Neurologic",
    "https://schema.org/Urologic"
  ],

   "availableService": [
    { "@type": "MedicalProcedure", "name": "Interventional Cardiology" },
    { "@type": "MedicalProcedure", "name": "Renal Transplant & Dialysis" },
    { "@type": "MedicalProcedure", "name": "Brain & Spine Surgery" },
    { "@type": "MedicalProcedure", "name": "Joint Replacement Surgery" }
  ],

  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.0",
    "reviewCount": "176"
  },

  "sameAs": [
    "https://www.facebook.com/HDNAAarogyamHospital/",
    "https://www.instagram.com/hdna_aarogyam_hospital/",
    "https://www.linkedin.com/company/hdna-aarogyam-hospital-patna/",
    "https://www.threads.com/@hdna_aarogyam_hospital",
    "https://x.com/HDNAAarogyam",
    "https://www.youtube.com/@HDNAAarogyamHospitalPatna"
  ]
};

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
};

export default SchemaContact;
